import React from 'react';
import { Grid, Icon, makeStyles, colors } from '@material-ui/core';
import { Block } from '@material-ui/icons';

import Description from 'components/typography/Description';

const useStyles = makeStyles({
  icon: {
    color: colors.red[400],
    height: 40,
    width: 40,
    fontSize: 40,
  },
});

const AccessBlocked = () => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={1} alignItems="center">
      <Grid item>
        <Icon className={classes.icon}>
          <Block fontSize="inherit"></Block>
        </Icon>
      </Grid>

      <Grid item>
        <Description>
          <b>This recipe is not yours</b>
        </Description>
      </Grid>
    </Grid>
  );
};

export default AccessBlocked;
